import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Pill } from '@els/els-react--pill';
import Breadcrumb from '@Services/Breadcrumb';
import { getSummaryResponse as getSummaryResponseSelector } from './selectors';
import useSummaryAvailable from './hooks/useSummaryAvailable';

import './InSummaryPillContainer.scss';

export function InSummaryPillContainer({ citation, databaseId, resultName, className, summaryResponse }) {
  const activeBreadcrumb = useMemo(() => Breadcrumb.getBreadcrumbForDbByResultName(databaseId, resultName), [databaseId, resultName]);
  const { isSummaryAvailable } = useSummaryAvailable({ activeBreadcrumb });

  const isCitationInSummary = useMemo(() => {
    if (!isSummaryAvailable || !summaryResponse) {
      return false;
    }

    const { referencedCitations } = summaryResponse;
    return referencedCitations?.some((referencedCit) => referencedCit?.id === citation?.id);
  }, [isSummaryAvailable, summaryResponse, citation]);

  return isCitationInSummary ? (
    <Pill pillColor="extended-blue-1" textColor="text" className={cn('ai-search-in-summary-pill', className)}>
      In summary
    </Pill>
  ) : null;
}

const mapStateToProps = (state) => ({
  summaryResponse: getSummaryResponseSelector(state),
});

export default connect(mapStateToProps, null)(InSummaryPillContainer);
